
import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import authentication from './containers/Authentication/AuthenticationReducer';
import business from './containers/Dashboard/DashboardReducer';
import invitations from './containers/Clients/InvitationsReducer';
import clients, {quotes as clientsQuotes, accessRequests, updateAccessRequests} from './containers/Clients/ClientsReducer';
import users, {signup} from './containers/Users/UsersReducer';
import self, {passwordUpdateSelf} from './containers/Header/HeaderReducer';
import baseRateUi from'./containers/BaseRates/BaseRateUiReducer';
import accessorialRateUi from './containers/AccessorialsAndFees/AccessorialsAndFeesUiReducer';
import register, {platformAccess, customerConfirmSignup} from './containers/Authentication/RegisterReducer';
import {accessorials, importAccessorials, updateAccessorial} from './containers/AccessorialsAndFees/AccessorialsAndFeesReducer';
import {settings} from './containers/Settings/SettingsReducer';
import {jobRequest} from './containers/Jobs/JobsReducer';
import version from './containers/SidebarFooter/SidebarFooterReducer';
import capacityTerminals from './containers/Capacity/CapacityReducers';

const rootReducer = combineReducers({
  router,
  authentication,
  form,
  business,
  invitations,
  clients,
  clientsQuotes,
  accessRequests,
  updateAccessRequests,
  users,
  signup,
  self,
  baseRateUi,
  accessorialRateUi,
  register,
  passwordUpdateSelf,
  accessorials,
  importAccessorials,
  updateAccessorial,
  settings,
  jobRequest,
  version,
  capacityTerminals,
  platformAccess,
  customerConfirmSignup
});

export default rootReducer;




// WEBPACK FOOTER //
// ./src/indexReducer.js